export const GROUP_PROFILE_ANY_REQUEST = 'GROUP_PROFILE_ANY_REQUEST';
export const GROUP_PROFILE_ANY_FAILED = 'GROUP_PROFILE_ANY_FAILED';

export const GET_GROUP_NEWS_SUCCESS = 'GET_GROUP_NEWS_SUCCESS';
export const GET_GROUP_TOPICS_SUCCESS = 'GET_GROUP_TOPICS_SUCCESS';
export const GET_GROUP_QUESTIONS_SUCCESS = 'GET_GROUP_QUESTIONS_SUCCESS';
export const GET_GROUP_QUESTIONS_IMPROVE_SUCCESS = 'GET_GROUP_QUESTIONS_IMPROVE_SUCCESS';
export const GET_GROUP_ANSWERS_SUCCESS = 'GET_GROUP_ANSWERS_SUCCESS';
export const GET_GROUP_BY_ID_SUCCESS = 'GET_GROUP_BY_ID_SUCCESS';
